import { AQSI_WINDOWS } from '@krp/resource-aqsi-ui'
import { OWN_KIND, OWN_WINDOWS } from '@krp/resource-own-ui'

import { useAqsiRmkSummary } from '../bindings/aqsi/useAqsiRmkSummary'
import { useOwnRmkSummary } from '../bindings/own/useOwnRmkSummary'
import type { RmkSourceExtension } from '../bindings/platform/rmkSourceTypes'

const EXTENSIONS: readonly RmkSourceExtension[] = [
  { kind: 'aqsi', window: AQSI_WINDOWS.rmk, useSummary: useAqsiRmkSummary },
  { kind: OWN_KIND, window: OWN_WINDOWS.sale, useSummary: useOwnRmkSummary },
]

/** Источники раздела «РМК» по виду ресурса: вид без расширения плитки не получает. */
export const RMK_SOURCES: ReadonlyMap<string, RmkSourceExtension> = new Map(EXTENSIONS.map((item) => [item.kind, item]))
